module.exports = __webpack_public_path__ + "img/brands_apply.5beb896c.jpg";